import { IconRegistry } from "./PortalIconRegistry";

export class IconBindingHandler implements KnockoutBindingHandler {
    public init(element: any, valueAccessor: () => string | null | undefined) {
        let iconKey = ko.unwrap(valueAccessor());
        if (iconKey) {
            if (IconBindingHandler.isThumbnail(iconKey)) {
                let img = document.createElement("img");
                $(img).attr("src", iconKey);
                $(img).attr("syn-data-type", $(element).attr("syn-data-type"));
                $(img).attr("class", $(element).attr("class"));
                $(element).replaceWith(img);
            } else {
                let iconValue = IconRegistry.getIcon(iconKey);
                if (iconValue) {
                    $(element).addClass(iconValue);
                }
            }
        }
    }

    static isThumbnail(iconKey: string): boolean {
        let matches = iconKey.match(/^data:image/g);
        return (matches != null && matches.length > 0);
    }
}